import { render, staticRenderFns } from "./Error404.vue?vue&type=template&id=6d9223b4&scoped=true&"
import script from "./Error404.vue?vue&type=script&lang=ts&"
export * from "./Error404.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d9223b4",
  null
  
)

export default component.exports